module.exports = __webpack_public_path__ + "img/advanced-created-card.f3d5b48b.png";